import React, { useEffect, useState } from "react";
import { Button, message } from "antd";

import CreateActoinModal from "./CreateActoinModal";
import ActionItem from "./components/ActionItem";
import { controller } from "./controller";
import { isNotEmpty } from "../../utils";
import EditActionModal from "./EditActionModal";

export default function CreateBoardFormAutomatedStepThree({ setAutomatedStep, boardId, campaignId, setCreateNewBoard, onBoardCreated }) {
  const [showAddActionModal, setShowAddActionModal] = useState(false);
  const [actions, setActions] = useState([]);
  const [deleting, setDeleting] = useState(false);
  const [showEditModal, setShowEditModal] = useState({id: null, show: false})

  const fetchActionsDetails = async () => {
    try {
      const response = await controller.getBoardDetails(boardId);
      // const actionsInBoard = response.json.campaign.actions;
      // console.log('boardDetails', actionsInBoard);
      // setSelectedAudiences(selectorsInBoard || []);
      setActions(response.json.campaign.actions)

    } catch (err) {
      message.error("We could not fetch board details, please check your connection");
      console.error("boardDetails", err);
    } finally {
      // setLoadingActions(false);
    }
  };

  useEffect(() => {
    fetchActionsDetails()
  }, [showAddActionModal])

  const handleDeleteAction = async (actionId) => {
    try {
      setDeleting(true)
      const response = await controller.removeAction(actionId)
      response.status === 204 && message.success(response.message)
      fetchActionsDetails()
    } catch (err) {
      message.error("Something went wrong while deleting the action")
      console.error("Delete action error", err)
    } finally {
      setDeleting(false)
    }
  }

  const handleEditAction = (actionId) => {
    setShowEditModal({id: actionId, show: true});    
  }

  const handleFinish = () => {
    onBoardCreated && onBoardCreated()
    setCreateNewBoard(false)
  }

  return (
    <>
      <div style={{ display: "flex", flexDirection: "column", justifyContent: "space-between", height: "100%" }}>
        <div>
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 20 }}>
            <p style={{ marginBottom: 0, fontSize: 16 }}>Action</p>

            {/* Check if there is any action to show or not */}
            {isNotEmpty(actions) && (
              <Button type="primary" style={{ fontSize: 12 }} onClick={() => setShowAddActionModal(true)}>
                Add Action
              </Button>
            )}
          </div>

          {/* Check if there is any action to show or not */}
          {isNotEmpty(actions) ? (
            <div style={{ display: "flex", flexDirection: "column", gap: 20 }}>
              {actions.map((action) => <ActionItem action={action} onDelete={handleDeleteAction} deleting={deleting} onEdit={handleEditAction}/>)}
            </div>
          ) : (
            <div
              style={{
                padding: "10px 20px",
                backgroundColor: "#F6F5FD",
                borderRadius: 10,
                border: "1px solid #E0DDF7",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: 20,
              }}
            >
              <p style={{ marginBottom: 0, fontSize: 16, textAlign: "center" }}>You don't have any actions yet, start by adding your first one.</p>

              <Button type="primary" style={{ padding: "10px 60px", fontSize: 13 }} onClick={() => setShowAddActionModal(true)}>
                Add First Action
              </Button>
            </div>
          )}
        </div>

        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <Button style={{ paddingInline: 40 }} onClick={() => setAutomatedStep("2")}>
            Back
          </Button>

          <Button style={{ paddingInline: 40 }} type="primary" onClick={handleFinish}> 
            Done
          </Button>
        </div>
      </div>

      {showAddActionModal && 
        <CreateActoinModal showAddActionModal={showAddActionModal} setShowAddActionModal={setShowAddActionModal} campaignId={campaignId} boardId={boardId} actions={actions}/>
      }
      
      {showEditModal.show && 
        <EditActionModal show={showEditModal} setShow={setShowEditModal} actions={actions} onEditDone={fetchActionsDetails}/>
      }
    </>
  );
}
